var map = {
	"./ad.svg": 4981,
	"./ae.svg": 6634,
	"./af.svg": 2921,
	"./ag.svg": 554,
	"./ai.svg": 7665,
	"./al.svg": 9564,
	"./am.svg": 3498,
	"./ao.svg": 7977,
	"./aq.svg": 1462,
	"./ar.svg": 2578,
	"./as.svg": 672,
	"./at.svg": 9796,
	"./au.svg": 466,
	"./aw.svg": 70,
	"./ax.svg": 6504,
	"./az.svg": 6807,
	"./ba.svg": 6471,
	"./bb.svg": 7756,
	"./bd.svg": 8513,
	"./be.svg": 1807,
	"./bf.svg": 447,
	"./bg.svg": 6984,
	"./bh.svg": 4655,
	"./bi.svg": 6553,
	"./bj.svg": 8789,
	"./bl.svg": 673,
	"./bm.svg": 3818,
	"./bn.svg": 17,
	"./bo.svg": 5042,
	"./bq.svg": 6790,
	"./br.svg": 2092,
	"./bs.svg": 3663,
	"./bt.svg": 5733,
	"./bv.svg": 2705,
	"./bw.svg": 3810,
	"./by.svg": 5558,
	"./bz.svg": 8733,
	"./ca.svg": 2894,
	"./cc.svg": 7158,
	"./cd.svg": 712,
	"./cf.svg": 2031,
	"./cg.svg": 6767,
	"./ch.svg": 6340,
	"./ci.svg": 3303,
	"./ck.svg": 5924,
	"./cl.svg": 7010,
	"./cm.svg": 7478,
	"./cn.svg": 6684,
	"./co.svg": 5934,
	"./cr.svg": 7331,
	"./cu.svg": 1451,
	"./cv.svg": 8589,
	"./cw.svg": 3264,
	"./cx.svg": 2338,
	"./cy.svg": 320,
	"./cz.svg": 9729,
	"./de.svg": 9173,
	"./dj.svg": 9606,
	"./dk.svg": 8482,
	"./dm.svg": 4100,
	"./do.svg": 696,
	"./dz.svg": 6683,
	"./ec.svg": 4578,
	"./ee.svg": 5390,
	"./eg.svg": 2109,
	"./eh.svg": 9191,
	"./er.svg": 5370,
	"./es.svg": 7414,
	"./et.svg": 8642,
	"./eu.svg": 4044,
	"./fi.svg": 1447,
	"./fj.svg": 6288,
	"./fk.svg": 8719,
	"./fm.svg": 3258,
	"./fo.svg": 4147,
	"./fr.svg": 3224,
	"./ga.svg": 3755,
	"./gb.svg": 6945,
	"./gd.svg": 8575,
	"./ge.svg": 5387,
	"./gf.svg": 2419,
	"./gg.svg": 8047,
	"./gh.svg": 5153,
	"./gi.svg": 8299,
	"./gl.svg": 1351,
	"./gm.svg": 8394,
	"./gn.svg": 5028,
	"./gp.svg": 2604,
	"./gq.svg": 6427,
	"./gr.svg": 959,
	"./gs.svg": 5197,
	"./gt.svg": 5228,
	"./gu.svg": 7036,
	"./gw.svg": 3547,
	"./gy.svg": 2325,
	"./hk.svg": 2963,
	"./hm.svg": 8695,
	"./hn.svg": 5526,
	"./hr.svg": 1267,
	"./ht.svg": 4840,
	"./hu.svg": 4610,
	"./id.svg": 1214,
	"./ie.svg": 6387,
	"./il.svg": 456,
	"./im.svg": 5722,
	"./in.svg": 7872,
	"./io.svg": 2232,
	"./iq.svg": 7230,
	"./ir.svg": 3306,
	"./is.svg": 5220,
	"./it.svg": 5246,
	"./je.svg": 7424,
	"./jm.svg": 913,
	"./jo.svg": 1549,
	"./jp.svg": 7448,
	"./ke.svg": 1415,
	"./kg.svg": 6950,
	"./kh.svg": 9995,
	"./ki.svg": 3149,
	"./km.svg": 161,
	"./kn.svg": 2241,
	"./kp.svg": 3112,
	"./kr.svg": 8142,
	"./kw.svg": 4313,
	"./ky.svg": 991,
	"./kz.svg": 4317,
	"./la.svg": 2656,
	"./lb.svg": 9749,
	"./lc.svg": 5269,
	"./li.svg": 887,
	"./lk.svg": 462,
	"./lr.svg": 3072,
	"./ls.svg": 9267,
	"./lt.svg": 3824,
	"./lu.svg": 6041,
	"./lv.svg": 8422,
	"./ly.svg": 6169,
	"./ma.svg": 9913,
	"./mc.svg": 5000,
	"./md.svg": 1536,
	"./me.svg": 4484,
	"./mf.svg": 4494,
	"./mg.svg": 7784,
	"./mh.svg": 4086,
	"./mk.svg": 9049,
	"./ml.svg": 6889,
	"./mm.svg": 2586,
	"./mn.svg": 3738,
	"./mo.svg": 7159,
	"./mp.svg": 191,
	"./mq.svg": 6976,
	"./mr.svg": 9347,
	"./ms.svg": 226,
	"./mt.svg": 1376,
	"./mu.svg": 9247,
	"./mv.svg": 7430,
	"./mw.svg": 1642,
	"./mx.svg": 4259,
	"./my.svg": 8347,
	"./mz.svg": 8776,
	"./na.svg": 8372,
	"./nc.svg": 7494,
	"./ne.svg": 8175,
	"./nf.svg": 3188,
	"./ng.svg": 2060,
	"./ni.svg": 623,
	"./nl.svg": 2571,
	"./no.svg": 3857,
	"./np.svg": 6290,
	"./nr.svg": 8950,
	"./nu.svg": 1261,
	"./nz.svg": 8341,
	"./om.svg": 7661,
	"./pa.svg": 6219,
	"./pe.svg": 6796,
	"./pf.svg": 2069,
	"./pg.svg": 1689,
	"./ph.svg": 4201,
	"./pirate.svg": 9571,
	"./pk.svg": 3884,
	"./pl.svg": 4143,
	"./pm.svg": 2861,
	"./pn.svg": 3708,
	"./pr.svg": 4466,
	"./ps.svg": 1161,
	"./pt.svg": 2317,
	"./pw.svg": 4196,
	"./py.svg": 7229,
	"./qa.svg": 5788,
	"./rainbow.svg": 2922,
	"./re.svg": 5904,
	"./ro.svg": 9883,
	"./rs.svg": 432,
	"./ru.svg": 6198,
	"./rw.svg": 7207,
	"./sa.svg": 8794,
	"./sb.svg": 741,
	"./sc.svg": 4874,
	"./sd.svg": 2667,
	"./se.svg": 935,
	"./sg.svg": 9510,
	"./sh.svg": 9081,
	"./si.svg": 7528,
	"./sj.svg": 6234,
	"./sk.svg": 7459,
	"./sl.svg": 902,
	"./sm.svg": 2471,
	"./sn.svg": 1975,
	"./so.svg": 4495,
	"./sr.svg": 9889,
	"./ss.svg": 9876,
	"./st.svg": 2717,
	"./sv.svg": 6043,
	"./sx.svg": 3006,
	"./sy.svg": 2462,
	"./sz.svg": 3736,
	"./tc.svg": 655,
	"./td.svg": 4235,
	"./tf.svg": 344,
	"./tg.svg": 7298,
	"./th.svg": 2737,
	"./tj.svg": 6242,
	"./tk.svg": 6795,
	"./tl.svg": 4022,
	"./tm.svg": 3433,
	"./tn.svg": 9097,
	"./to.svg": 400,
	"./tr.svg": 4592,
	"./trans.svg": 7598,
	"./tt.svg": 1259,
	"./tv.svg": 8724,
	"./tw.svg": 3271,
	"./tz.svg": 2302,
	"./ua.svg": 1576,
	"./ug.svg": 3002,
	"./um.svg": 1898,
	"./us.svg": 9179,
	"./uy.svg": 4720,
	"./uz.svg": 7491,
	"./va.svg": 7260,
	"./vc.svg": 6870,
	"./ve.svg": 6548,
	"./vg.svg": 6626,
	"./vi.svg": 7668,
	"./vn.svg": 7970,
	"./vu.svg": 7861,
	"./wf.svg": 7580,
	"./ws.svg": 482,
	"./ye.svg": 9332,
	"./yt.svg": 8387,
	"./za.svg": 5365,
	"./zm.svg": 9467,
	"./zw.svg": 9651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4027;